export enum GamesActionTypes {
    GET_GAMES = "[App Action][Games] GET GAMES",
    GET_GAMES_SUCCESS = "[App Action][Games] GET GAMES SUCCESS",
    GET_GAMES_FAIL = "[App Action][Games] GET GAMES FAIL",

    SEARCH_GAMES = "[App Action][Games] SEARCH GAMES",
    SEARCH_GAMES_SUCCESS = "[App Action][Games] SEARCH GAMES SUCCESS",
    SEARCH_GAMES_FAIL = "[App Action][Games] SEARCH GAMES FAIL",

    CLEAR_SEARCH_GAMES = "[App Action][Games] CLEAR SEARCH GAMES",

    MOVE_GAME_CONF = "[App Action][Games] MOVE GAME CONF",
    MOVE_GAME_CONF_SUCCESS = "[App Action][Games] MOVE GAME CONF SUCCESS",
    MOVE_GAME_CONF_FAIL = "[App Action][Games] MOVE GAME CONF FAIL",

    GET_GAME_CONFIGURATIONS = "[App Action][Games] GET GAME CONFIGURATIONS",
    GET_GAME_CONFIGURATIONS_SUCCESS = "[App Action][Games] GET GAME CONFIGURATIONS SUCCESS",
    GET_GAME_CONFIGURATIONS_FAIL = "[App Action][Games] GET GAME CONFIGURATIONS FAIL",

    GET_GAME_ENGINES = "[App Action][Games] GET GAME ENGINES",
    GET_GAME_ENGINES_SUCCESS = "[App Action][Games] GET GAME ENGINES SUCCESS",
    GET_GAME_ENGINES_FAIL = "[App Action][Games] GET GAME ENGINES FAIL",

    GET_GAME_ENGINES_SCHEMAS = "[App Action][Games] GET GAME ENGINES SCHEMAS",
    GET_GAME_ENGINES_SCHEMAS_SUCCESS = "[App Action][Games] GET GAME ENGINES SCHEMAS SUCCESS",
    GET_GAME_ENGINES_SCHEMAS_FAIL = "[App Action][Games] GET GAME ENGINES SCHEMAS FAIL",

    GET_GAME_INSTANCES = "[App Action][Games] GET GAME INSTANCES",
    GET_GAME_INSTANCES_SUCCESS = "[App Action][Games] GET GAME INSTANCES SUCCESS",
    GET_GAME_INSTANCES_FAIL = "[App Action][Games] GET GAME INSTANCES FAIL",

    GET_GAME_CONFIGS = "[App Action][Games] GET GAME CONFIGS",
    GET_GAME_CONFIGS_SUCCESS = "[App Action][Games] GET GAME CONFIGS SUCCESS",
    GET_GAME_CONFIGS_FAIL = "[App Action][Games] GET GAME CONFIGS FAIL",

    GET_SUBSIDIARIES = "[App Action][Games] GET SUBSIDIARIES",
    GET_SUBSIDIARIES_SUCCESS = "[App Action][Games] GET SUBSIDIARIES SUCCESS",
    GET_SUBSIDIARIES_FAIL = "[App Action][Games] GET SUBSIDIARIES FAIL",

    /*GET_GAME_CONFIGURATION = "[App Action][Games] GET GAME CONFIGURATION",
    GET_GAME_CONFIGURATION_SUCCESS = "[App Action][Games] GET GAME CONFIGURATION SUCCESS",
    GET_GAME_CONFIGURATION_FAIL = "[App Action][Games] GET GAME CONFIGURATION FAIL",*/

    CREATION_MODE_CHANGE = "[App Action][Games] CREATION MODE CHANGE",

    CREATE_GAME = "[App Action][Games] CREATE GAME",
    CREATE_GAME_SUCCESS = "[App Action][Games] CREATE GAME SUCCESS",
    CREATE_GAME_FAIL = "[App Action][Games] CREATE GAME FAIL",
    CREATE_GAME_RESET = "[App Action][Games] CREATE GAME RESET",
    UPDATE_CREATING_GAME = "[App Action][Games] UPDATE CREATING GAME",

    EDIT_GAME = "[App Action][Games] EDIT GAME",
    EDIT_GAME_SUCCESS = "[App Action][Games] EDIT GAME SUCCESS",
    EDIT_GAME_FAIL = "[App Action][Games] EDIT GAME FAIL",

    GET_GAME = "[App Action][Games] GET GAME",
    GET_GAME_SUCCESS = "[App Action][Games] GET GAME SUCCESS",
    GET_GAME_FAIL = "[App Action][Games] GET GAME FAIL",
    CLEAR_GAME = "[App Action][Games] CLEAR GAME",

    CREATE_CONF = "[App Action][Games] CREATE CONFIGURATION",
    CREATE_CONF_SUCCESS = "[App Action][Games] CREATE CONFIGURATION SUCCESS",
    CREATE_CONF_FAIL = "[App Action][Games] CREATE CONFIGURATION FAIL",
    CREATE_CONF_RESET = "[App Action][Games] CREATE CONFIGURATION RESET",
    UPDATE_CREATING_CONF = "[App Action][Games] UPDATE CREATING CONFIGURATION",

    EDIT_CONF = "[App Action][Games] EDIT CONFIGURATION",
    EDIT_CONF_SUCCESS = "[App Action][Games] EDIT CONFIGURATION SUCCESS",
    EDIT_CONF_FAIL = "[App Action][Games] EDIT CONFIGURATION FAIL",

    DELETE_CONF = "[App Action][Games] DELETE CONFIGURATION",
    DELETE_CONF_SUCCESS = "[App Action][Games] DELETE CONFIGURATION SUCCESS",
    DELETE_CONF_FAIL = "[App Action][Games] DELETE CONFIGURATION FAIL",

    GET_BUNDLES = "[App Action][Games] GET BUNDLES",
    GET_BUNDLES_SUCCESS = "[App Action][Games] GET BUNDLES SUCCESS",
    GET_BUNDLES_FAIL = "[App Action][Games] GET BUNDLES FAIL",

    CREATE_BUNDLE = "[App Action][Games] CREATE BUNDLE",
    CREATE_BUNDLE_SUCCESS = "[App Action][Games] CREATE BUNDLE SUCCESS",
    CREATE_BUNDLE_FAIL = "[App Action][Games] CREATE BUNDLE FAIL",

    EDIT_BUNDLE = "[App Action][Games] EDIT BUNDLE",
    EDIT_BUNDLE_SUCCESS = "[App Action][Games] EDIT BUNDLE SUCCESS",
    EDIT_BUNDLE_FAIL = "[App Action][Games] EDIT BUNDLE FAIL",

    CREATE_BUNDLE_RESET = "[App Action][Games] CREATE BUNDLE RESET",
    UPDATE_CREATING_BUNDLE = "[App Action][Games] UPDATE CREATING BUNDLE",

    DELETE_BUNDLE = "[App Action][Games] DELETE BUNDLE",
    DELETE_BUNDLE_SUCCESS = "[App Action][Games] DELETE BUNDLE SUCCESS",
    DELETE_BUNDLE_FAIL = "[App Action][Games] DELETE BUNDLE FAIL",

    GET_SUBSIDIARY_CONFIGURATIONS = "[App Action][Games] GET SUBSIDIARY CONFIGURATIONS",
    GET_SUBSIDIARY_CONFIGURATIONS_SUCCESS = "[App Action][Games] GET SUBSIDIARY CONFIGURATIONS SUCCESS",
    GET_SUBSIDIARY_CONFIGURATIONS_FAIL = "[App Action][Games] GET SUBSIDIARY CONFIGURATIONS FAIL",

    LOAD_JSON = "[App Action][Games] LOAD JSON",
    LOAD_JSON_SUCCESS = "[App Action][Games] LOAD JSON SUCCESS",
    LOAD_JSON_FAIL = "[App Action][Games] LOAD JSON FAIL",
    LOAD_JSON_RESET = "[App Action][Games] LOAD JSON RESET",

    CREATE_ALIAS = "[App Action][Games] CREATE ALIAS",
    CREATE_ALIAS_SUCCESS = "[App Action][Games] CREATE ALIAS SUCCESS",
    CREATE_ALIAS_FAIL = "[App Action][Games] CREATE ALIAS FAIL",

    ACTIVATE_CONF = "[App Action][Games] ACTIVATE CONF",
    ACTIVATE_CONF_SUCCESS = "[App Action][Games] ACTIVATE CONF SUCCESS",
    ACTIVATE_CONF_FAIL = "[App Action][Games] ACTIVATE CONF FAIL",

    GET_GAME_ATTRIBUTES = "[App Action][Games] GET GAME ATTRIBUTES",
    GET_GAME_ATTRIBUTES_SUCCESS = "[App Action][Games] GET GAME ATTRIBUTES SUCCESS",
    GET_GAME_ATTRIBUTES_FAIL = "[App Action][Games] GET GAME ATTRIBUTES FAIL",

    GET_GAME_ATTRIBUTES_FEATURES = "[App Action][Games] GET GAME ATTRIBUTES FEATURES",
    GET_GAME_ATTRIBUTES_FEATURES_SUCCESS = "[App Action][Games] GET GAME ATTRIBUTES FEATURES SUCCESS",
    GET_GAME_ATTRIBUTES_FEATURES_FAIL = "[App Action][Games] GET GAME ATTRIBUTES FEATURES FAIL",

    GET_GAME_ATTRIBUTES_SERIES = "[App Action][Games] GET GAME ATTRIBUTES SERIES",
    GET_GAME_ATTRIBUTES_SERIES_SUCCESS = "[App Action][Games] GET GAME ATTRIBUTES SERIES SUCCESS",
    GET_GAME_ATTRIBUTES_SERIES_FAIL = "[App Action][Games] GET GAME ATTRIBUTES SERIES FAIL",

    GET_GAME_ATTRIBUTES_PLATFORM = "[App Action][Games] GET GAME ATTRIBUTES PLATFORM",
    GET_GAME_ATTRIBUTES_PLATFORM_SUCCESS = "[App Action][Games] GET GAME ATTRIBUTES PLATFORM SUCCESS",
    GET_GAME_ATTRIBUTES_PLATFORM_FAIL = "[App Action][Games] GET GAME ATTRIBUTES PLATFORM FAIL",

    GET_GAME_ATTRIBUTES_TYPE = "[App Action][Games] GET GAME ATTRIBUTES TYPE",
    GET_GAME_ATTRIBUTES_TYPE_SUCCESS = "[App Action][Games] GET GAME ATTRIBUTES TYPE SUCCESS",
    GET_GAME_ATTRIBUTES_TYPE_FAIL = "[App Action][Games] GET GAME ATTRIBUTES TYPE FAIL",

    GET_GAME_ATTRIBUTES_TRADEMARKS = "[App Action][Games] GET GAME ATTRIBUTES TRADEMARKS",
    GET_GAME_ATTRIBUTES_TRADEMARKS_SUCCESS = "[App Action][Games] GET GAME ATTRIBUTES TRADEMARKS SUCCESS",
    GET_GAME_ATTRIBUTES_TRADEMARKS_FAIL = "[App Action][Games] GET GAME ATTRIBUTES TRADEMARKS FAIL",

    GET_CLIENTS = "[App Action][Games] GET CLIENTS",
    GET_CLIENTS_SUCCESS = "[App Action][Games] GET CLIENTS SUCCESS",
    GET_CLIENTS_FAIL = "[App Action][Games] GET CLIENTS FAIL",

    EDIT_GAME_ATTRIBUTE = "[App Action][Games] EDIT GAME ATTRIBUTE",
    EDIT_GAME_ATTRIBUTE_SUCCESS = "[App Action][Games] EDIT GAME ATTRIBUTE SUCCESS",
    EDIT_GAME_ATTRIBUTE_FAIL = "[App Action][Games] EDIT GAME ATTRIBUTE FAIL",

    GET_GAME_CREATION_ATTRIBUTES = "[App Action][Games] GET GAME CREATION ATTRIBUTES",
    GET_GAME_CREATION_ATTRIBUTES_SUCCESS = "[App Action][Games] GET GAME CREATION ATTRIBUTES SUCCESS",
    GET_GAME_CREATION_ATTRIBUTES_FAIL = "[App Action][Games] GET GAME CREATION ATTRIBUTES FAIL",

    CREATE_GAME_ATTRIBUTE = "[App Action][Games] CREATE GAME ATTRIBUTE",
    CREATE_GAME_ATTRIBUTE_SUCCESS = "[App Action][Games] CREATE GAME ATTRIBUTE SUCCESS",
    CREATE_GAME_ATTRIBUTE_FAIL = "[App Action][Games] CREATE GAME ATTRIBUTE FAIL",

    CREATION_ATTR_MODE_CHANGE = "[App Action][Games] CREATION ATTR MODE CHANGE",

    GET_DENOMINATIONS = "[App Action][Games] GET DENOMINATIONS",
    GET_DENOMINATIONS_SUCCESS = "[App Action][Games] GET DENOMINATIONS SUCCESS",
    GET_DENOMINATIONS_FAIL = "[App Action][Games] GET DENOMINATIONS FAIL",

    GET_GAME_CATEGORIES = "[App Action][Games] GET GAME CATEGORIES",
    GET_GAME_CATEGORIES_SUCCESS = "[App Action][Games] GET GAME CATEGORIES SUCCESS",
    GET_GAME_CATEGORIES_FAIL = "[App Action][Games] GET GAME CATEGORIES FAIL",

    SAVE_GAME_CATEGORY = "[App Action][Games] SAVE GAME CATEGORY",
    SAVE_GAME_CATEGORY_SUCCESS = "[App Action][Games] SAVE GAME CATEGORY SUCCESS",
    SAVE_GAME_CATEGORY_FAIL = "[App Action][Games] SAVE GAME CATEGORY FAIL",

    DELETE_GAME_CATEGORY = "[App Action][Games] DELETE GAME CATEGORY",
    DELETE_GAME_CATEGORY_SUCCESS = "[App Action][Games] DELETE GAME CATEGORY SUCCESS",
    DELETE_GAME_CATEGORY_FAIL = "[App Action][Games] DELETE GAME CATEGORY FAIL",

    SET_CATEGORY_SUBSIDIARIES = "[App Action][Games] SET CATEGORY SUBSIDIARIES",
    SET_CATEGORY_SUBSIDIARIES_SUCCESS = "[App Action][Games] SET CATEGORY SUBSIDIARIES SUCCESS",
    SET_CATEGORY_SUBSIDIARIES_FAIL = "[App Action][Games] SET CATEGORY SUBSIDIARIES FAIL"
}
